const ClickToPay = require('./ClickToPay');


class GeideaIntegration extends ClickToPay {
  constructor(submitUrl, paymentMethod, currScript, fieldsService) {
    super(submitUrl, paymentMethod, currScript, fieldsService);
    this.geideaPayment = null;
  }

  async _performInitialization() {
    try {
      const response = await this.fetchVendorScript();

      const sdkUrl =
        response.sdk_url || response.js_sdk_src || response.sdk_client?.src;

      if (!sdkUrl) {
        throw new Error('Geidea SDK URL not found in response');
      }

      await this.loadVendorScript(sdkUrl);

      return response;
    } catch (error) {
      console.error('[Geidea] Initialization error:', error);
      throw error;
    }
  }

  async handlePayment(response) {
    const { session_id, ws_url, reference_number } = response;

    if (!session_id) {
      throw new Error('Geidea integration: session_id not found in response');
    }

    // Wait for Geidea SDK to be available
    await this.waitForDependency();

    const onSuccess = (response) => {
      console.log('[Geidea] Success callback', response);
    };

    const onError = (response) => {
      console.log('[Geidea] Error callback', response);
    };

    const onCancel = (response) => {
      console.log('[Geidea] Cancel callback', response);
    };

    this.geideaPayment = new GeideaCheckout(onSuccess, onError, onCancel);

    this.geideaPayment.startPayment(session_id);

    this.fieldsService.disableEnableFields(false);

    await this.handleWebSocket({
      ws_url: ws_url,
      reference_number: reference_number,
    });
  }

  checkDependency() {
    return typeof GeideaCheckout === 'function';
  }

  destroy() {
    if (this.geideaPayment) {
      // Geidea SDK may not have explicit destroy method
      // but we clear the reference
      this.geideaPayment = null;
    }
  }
}

module.exports = GeideaIntegration;
